import { ReactNode, useMemo } from 'react';
import { TransactionHistoryContext } from './TransactionHistoryContext';
import { TransactionsHistoryHostProps } from './types';

type TransactionHistoryProviderProps = TransactionsHistoryHostProps & {
  children: ReactNode;
};

// Feature-local, not app-level: the Transaction History root mounts this with the props the host passed
// it, so the feature's internal children (the table config) read useTransactionHistory() instead of being
// handed viewer/account/hostPaths one level at a time. Deliberately not exported from the package barrel —
// the host mounts only the root and passes props. The filter form is a separate exported surface, so it
// takes everything as props and never reads this.
export default function TransactionHistoryProvider({
  viewer,
  account,
  userPermissions,
  hostPaths,
  showAccountName,
  hiddenFilters,
  hiddenExports,
  hiddenColumns,
  transactionsSource,
  children,
}: TransactionHistoryProviderProps) {
  const value = useMemo(
    () => ({
      viewer,
      account,
      userPermissions,
      hostPaths,
      showAccountName,
      hiddenFilters,
      hiddenExports,
      hiddenColumns,
      transactionsSource,
    }),
    [
      viewer,
      account,
      userPermissions,
      hostPaths,
      showAccountName,
      hiddenFilters,
      hiddenExports,
      hiddenColumns,
      transactionsSource,
    ],
  );

  return <TransactionHistoryContext.Provider value={value}>{children}</TransactionHistoryContext.Provider>;
}
